window.addEventListener('DOMContentLoaded', () => {
  if (document.location.hash.length) {
    const $projectOpener = document.querySelector(`.js-project a[href="${document.location.hash}"]`);
    if ($projectOpener !== null) {
      $projectOpener.click();
    }
  }

  // TODO: fix chrome bug and remove timeout
  window.setTimeout(() => {
    if ('IntersectionObserver' in window) {
      const observer = window.lozad('img.lozad');
      observer.observe();
    } else {
      const $images = document.querySelectorAll('img.lozad');
      $images.forEach(($image) => {
        $image.setAttribute('src', $image.getAttribute('data-src'));
      });
    }
  }, 200);
});
